export const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'RESET_STATE':
      return {};
    case 'SET_AUTHENTICATION':
      return { ...state, authenticated: action.payload };
    case 'GET_ALL_ASSETS':
      return { ...state, assets: action.payload };
    case 'SET_CONFIG_FILE':
      return { ...state, configFile: action.payload };
    case 'SET_TEMP_CONFIG_FILE':
      return { ...state, tempConfigFile: action.payload };
    case 'GET_FILTERED_ASSETS':
      return { ...state, filteredAssets: action.payload };
    case 'GET_FILTERS':
      return { ...state, filters: action.payload };
    case 'SET_ROLES':
      return { ...state, roles: action.payload };
    case 'GET_ALL_USERS':
      return { ...state, users: action.payload };
    case 'ADD_USER': {
      const newUsersObject = state.users;
      newUsersObject[Object.keys(newUsersObject).length] = action.payload;
      return Object.assign({}, state, {
        users: newUsersObject
      });
    }
    case 'DISABLE_USER':
    case 'EDIT_USER': {
      const newUsersObjectEdited = Object.assign({}, state.users);
      const userKey = Object.keys(state.users).findIndex(
        e => state.users[e].id === action.payload.id
      );

      const newUserEdited = action.payload;

      newUsersObjectEdited[userKey] = newUserEdited;

      return Object.assign({}, state, {
        users: newUsersObjectEdited
      });
    }
    default:
      return state;
  }
};
